import { useContext, useEffect } from 'react';

import { UiStateContext } from '../../contexts/ui-state/UiStateContext';
import { AlertsContent } from '../../models/app-data-model';
import useGetBlob from '../get-blob/get-blob/useGetBlob';

// This hook fetches component (e.g. subsites/pages) specific alerts
function useComponentAlerts(ComponentAlerts: AlertsContent[], alertType: 'page' | 'subsite'): void {
  const alertBlobs = useGetBlob(ComponentAlerts);
  const uiStateContext = useContext(UiStateContext);

  useEffect(() => {
    const openAlerts: AlertsContent[] = [];

    ComponentAlerts?.forEach((alert, index) => {
      /* istanbul ignore else */
      if (typeof localStorage !== 'undefined' && alert.alert !== null) {
        if (localStorage.getItem(alertBlobs[index]) !== 'closed' && alert !== null) {
          openAlerts.push(alert);
        }
      }
    });

    switch (alertType) {
      case 'subsite':
        uiStateContext.setSubsiteAlerts(openAlerts);
        break;
      case 'page':
        uiStateContext.setPageAlerts(openAlerts);
        break;
      default:
        throw new Error('tried to render an alert with invalid alert type. Alert type = ' + alertType);
    }

    // Ignoring deps that cause infinite rerendering
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ComponentAlerts]);
}

export default useComponentAlerts;
